module.exports = __webpack_public_path__ + "media/audio2.2554e12e.mp3";